<template>
  <div class="c-search-input">
    <form @submit.prevent="sendSearchText">
      <button
        class="c-search-input__button"
        @click="focusInput()"
        :aria-label="`${$t('FOCUS_INPUT')}`">
        <search-icon
          class="c-search-input__search-icon"
          fill="#363a5e"
          @click.native="focusInput()">
        </search-icon>
      </button>
      <input
        class="c-search-input__input"
        v-model="searchText"
        :placeholder="$t('SEARCH_PLACEHOLDER')"
        :aria-label="$t('SEARCH_IN_BOOK')"
        type="text"
        ref="searchInput"
        :aria-invalid="searchTextEmpty">
      <button
        class="c-search-input__clear-button"
        v-if="searchText.length > 0"
        @click="clearSearchText()"
        :aria-label="`${$t('CLEAR_INPUT')}`">
        <close-in-circle
          class="c-search-input__close-icon">
        </close-in-circle>
      </button>
    </form>
    <div
      v-if="searchTextEmpty"
      class="c-search-input__error"
      role="alert">
      {{ $t('SEARCH_EMPTY_TEXT') }}
    </div>
  </div>
</template>

<script>
import SearchIcon from '@/assets/svg/SearchIcon'
import CloseInCircle from '@/assets/svg/CloseInCircle'

export default {
  name: 'SearchInput',

  components: {
    'search-icon': SearchIcon,
    'close-in-circle': CloseInCircle
  },

  data() {
    return {
      searchText: '',
      searchTextEmpty: false
    }
  },

  methods: {
    focusInput() {
      this.$refs.searchInput.focus()
    },

    sendSearchText($event) {
      if(this.searchText !== '') {
        this.$emit('search-text', this.searchText)
        this.searchTextEmpty = false
      } else {
        this.searchTextEmpty = true
      }
    },

    clearSearchText() {
      this.searchText = ''
      this.$emit('search-text-clear')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_vars.scss';
@import '@/assets/scss/_mixin.scss';

.c-search-input {
  width: 100%;
  position: relative;
}

.c-search-input__input {
  width: 100%;
  background-color: $white;
  box-shadow: none;
  appearance: none;
  border: 1px solid $dark-blue;
  border-radius: 1.3em;
  height: 2em;
  font-size: 0.875em;
  padding-left: 2.75em;
  color: $dark-blue;
  outline: none;

  &::placeholder {
    color: $dark-blue;
    opacity: 1;
  }

  &::-ms-clear {
    display: none;
  }
}

.c-search-input__button {
  @include btnReset();
  position: absolute;
  left: 0.875em;
  top: -0.1em;
  cursor: pointer;
  font-size: 1rem;

  @include a11yOutline();
}

.c-search-input__search-icon {
  width: 1.3em;
}

.c-search-input__clear-button {
  @include btnReset();
  position: absolute;
  right: 0.23em;
  height: 100%;
  cursor: pointer;
  font-size: 1rem;

  @include a11yOutline();
}

.c-search-input__close-icon {
  width: 1.48em;
  margin: auto;
  display: block;
  height: 100%;
}
.c-search-input__error {
  color: $red-level;
}
</style>
